<template>
  <div>
    <ProductSliderSteps
      v-if="widthSteps"
      :products="listProducts"
      @click="onStepClick"
      :activeStepId="activeStepId"
      :text-steps="textSteps"
      class="container-small"
    />
    <ModuleImageSlider
      :sliders="listSliders"
      class="sliders"
      :slideActiveId="slideActiveId"
      @activeStepId="activeStepId = $event"
      :pagination="pagination"
    >
      <template v-slot:default="slideProps">
        <ModuleProduct v-bind="slideProps.data" class="container-small" />
      </template>
    </ModuleImageSlider>
  </div>
</template>
<script lang="ts" setup="props">
import { ref, reactive, computed } from 'vue'

import ModuleImageSlider from '@/components/module/ModuleImageSlider.vue'
import ModuleProduct from '@/components/module/ModuleProduct.vue'
import ProductSliderSteps from '@/components/ProductSlider/Steps.vue'
import { IProducts, IProduct } from './ProductSlider'

/**
 * @property {String} title
 * @description could be used with title prop or default slot
 */
const props = defineProps<{
  listProducts: IProducts[]
  pagination: boolean
  widthSteps: boolean
  textSteps?: string[]
}>()

const slideActiveId = ref(0)

const activeStepId = ref('')

const listSliders = computed(() => {
  return flattenProduct(props.listProducts)
})

function flattenProduct(items: any) {
  const flat: any = []

  items.forEach((item: any) => {
    if (item.children?.length > 0) {
      flat.push(...flattenProduct(item.children))
    } else {
      flat.push(item)
    }
  })

  return flat
}

function onStepClick(id: number) {
  slideActiveId.value = id
}
</script>
